const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((vitals) => {
      const {
        getCLS,
        getFID,
        getFCP,
        getLCP,
        getTTFB,
        onINP,
        getINP
      } = vitals;
      if (typeof getCLS === 'function') getCLS(onPerfEntry);
      if (typeof getFID === 'function') getFID(onPerfEntry);
      if (typeof getFCP === 'function') getFCP(onPerfEntry);
      if (typeof getLCP === 'function') getLCP(onPerfEntry);
      if (typeof getTTFB === 'function') getTTFB(onPerfEntry);
      if (typeof onINP === 'function') onINP(onPerfEntry);
      else if (typeof getINP === 'function') getINP(onPerfEntry);
    });
  }
};

export default reportWebVitals;
